import { useExactMatchedRoute } from 'common/hooks/routeHookHelpers';
import { isReportBuilderLivePreviewEnabled } from '../../helpers/featureFlags';

const allowedReportPreviewPages = [
  'key-focus-areas/:hypothesisId/edit',
  'analyses/:analysisId/edit',
  'analyses/quality-of-earnings/edit',
  'analyses/net-working-capital/edit',
  'analyses/debt-debt-like/edit',
];

export const useShouldDisplayReportPreview = () => {
  const matchedRoute = useExactMatchedRoute() as Record<string, string>;

  if (!matchedRoute || !isReportBuilderLivePreviewEnabled) return false;

  const { path } = matchedRoute;
  return allowedReportPreviewPages.some((page) => path.endsWith(page));
};
